if (!customElements.get('text-tabs')) {
  class TextTabs extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.tabButtons = this.querySelectorAll('.textTab-wrapper');
      this.tabContents = this.querySelectorAll('.textTab-contentWrapper');
      this.tabButtons.forEach(tabButton => {
        tabButton.addEventListener('click', event => {
          this.tabClick(event);
        });
      });
    }
    tabClick(event) {
      const currentIndex = event.currentTarget.getAttribute('data-tab-index');
      if (event.currentTarget.classList.contains('active')) return;
      this.tabButtons.forEach(tabButton => {
        tabButton.classList.remove('active');
      });
      event.currentTarget.classList.add('active');
      this.tabContents.forEach(tabContent => {
        tabContent.classList.remove('active');
      });
      this.tabContents.forEach(tabContent => {
        if (tabContent.getAttribute('data-content-index') == currentIndex) {
          tabContent.classList.add('active');
        }
      })
    }
  }
  customElements.define('text-tabs', TextTabs);
}